import { render } from "./approv_create.vue?vue&type=template&id=6be69393"
import script from "./approv_create.vue?vue&type=script&lang=js"
export * from "./approv_create.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__